import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { theme } from "../../styles";
import { PlusOutlined } from "@ant-design/icons";
import {
  getAllClothQualities,
  deleteClothQuality,
} from "../../helper/utils/api/settings";
import EditClothQualityModal from "../../components/Modals/Setting/EditClothQualityModal";

import { Grid, Tabel, DropDown, Button, Typography, Loading } from "../../core";
import AddClothQualityModal from "../../components/Modals/Setting/AddClothQualityModal";
import DeleteModals from "../../components/Modals/deleteModals";
const { colors } = theme;
const btnProps = {
  width: "130px",
  height: "30px",
  bg: colors.pink,
  margin: "10px 0px 10px auto",
};
const typoProps = {
  align: "center",
  as: "h6",
  weight: "600",
  color: "white",
};
const ClothQuality = () => {
  const [modalState, setModalState] = useState({
    addClothQaulityModal: false,
    editClothQualityModal: false,
    deleteConfirmModal: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [record, setRecord] = useState({
    recordToDelete: {},
    recordToEdit: {},
  });
  const [clothQualities, setClothQualities] = useState([]);

  useEffect(() => {
    getClothQualities();
  }, []);

  const clothQualityDeleteHandler = (record) => {
    setModalState((prev) => ({
      ...prev,
      deleteConfirmModal: true,
    }));
    setRecord({
      recordToDelete: record,
      recordToEdit: {},
    });
  };

  const clothQualityEditHandler = (record) => {
    console.log("record", record);

    setModalState((prev) => ({
      ...prev,
      editClothQualityModal: true,
    }));
    setRecord({
      recordToDelete: {},
      recordToEdit: record,
    });
  };

  const menu = (index, record) => {
    return (
      <Menu>
        <Menu.Item onClick={() => clothQualityDeleteHandler(record)}>
          Delete
        </Menu.Item>
        <Menu.Item onClick={() => clothQualityEditHandler(record)}>
          Edit
        </Menu.Item>
      </Menu>
    );
  };

  const getClothQualities = async () => {
    let companyId = localStorage.getItem("companyId");
    if (companyId) {
      setIsLoading(true);
      try {
        let {
          data: { result },
        } = await getAllClothQualities({ companyId });

        setClothQualities(result);
      } catch (error) {
        console.log("error from get cloth quality", error);
      }
      setIsLoading(false);
    }
  };

  const openModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const confirmDeleteHandler = async () => {
    if (record.recordToDelete) {
      let { _id } = record.recordToDelete;
      if (_id) {
        setIsLoading(true);
        try {
          await deleteClothQuality(_id);
          closeModal("deleteConfirmModal");
          await getClothQualities();
        } catch (error) {}
        setIsLoading(false);
      }
    }
  };

  const columns = [
    {
      title: "SR #",
      dataIndex: "sr",
      key: "S.No",
      render: (text, record, index) => {
        return <span>{index + 1}</span>;
      },
      width: 150,
    },
    {
      title: "Warp",
      dataIndex: "warp",
      key: "warp",
      width: 150,
    },
    {
      title: "Weft ",
      dataIndex: "weft",
      key: "weft",
      width: 150,
    },
    {
      title: "Reed",
      dataIndex: "reed",
      key: "reed",
      width: 150,
    },
    {
      title: "Pick",
      dataIndex: "pick",
      key: "pick",
      width: 150,
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
      width: 150,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 150,
    },
    {
      title: "",
      dataIndex: "action",
      width: 150,
      render: (text, record, index) => (
        <DropDown overlay={() => menu(index, record)} />
      ),
    },
  ];

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <div>
        <Button {...btnProps} onClick={() => openModal("addClothQaulityModal")}>
          <Typography {...typoProps} noMargin>
            <PlusOutlined />
            Add Cloth Quality
          </Typography>
        </Button>
      </div>

      <Tabel columns={columns} data={clothQualities} />
      {modalState.addClothQaulityModal && (
        <AddClothQualityModal
          addClothQaulityModal={modalState.addClothQaulityModal}
          getClothQualities={getClothQualities}
          closeModal={closeModal}
        />
      )}

      {modalState.deleteConfirmModal && (
        <DeleteModals
          deleteModalsOpen={modalState.deleteConfirmModal}
          closeModal={closeModal}
          confirmDeleteHandler={confirmDeleteHandler}
        />
      )}

      {modalState.editClothQualityModal && (
        <EditClothQualityModal
          editClothQualityModal={modalState.editClothQualityModal}
          closeModal={closeModal}
          getClothQualities={getClothQualities}
          dataToEdit={record.recordToEdit}
        />
      )}
    </Grid>
  );
};

export default ClothQuality;
